import { useEffect, useState } from "react";
import ReportType from "./ReportType";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import { SearchDatePickerWrapper } from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import { SearchSelectWithList } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { SearchSelectWithIndeterminateBoolean } from "../../../../components/common/datatable/DataTableUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useLazyExportDailyOrderReportDataQuery, useSearchDailyOrderCountReportApiQuery } from "../report";
import { useGetAllCustomersListQuery } from "../../../customer/customerApi";

const DailyOrderCountReport = () => {
    const customerData = useGetAllCustomersListQuery("");
    const [type, setType] = useState('DAILY_ORDER_COUNT');
    const [triggerExportReportDataQuery] = useLazyExportDailyOrderReportDataQuery();

    useEffect(() => {
        document.title = 'Reports';
    }, []);


    useEffect(() => {
        let x = document.getElementById("grid");
        if (x !== null) {
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
    }, [])


    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Daily Order Count Report", url: "" }]
    );

    const columns: DataTableColumn[] = [
        {
            label: "Created", accessor: "creationDate", visibility: { hasShowSetting: false }, canSort: false,
            cell: (props: any) => {
                return props.value ? formatValueAsDateAndTime(props.value, "MM/D/YYYY") : '';
            }, filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"} />,
                overrideFilterAccessor: "createdDateFrom",
                overrideFilterLabel: "Created Date - From",
            }, {
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"} />,
                overrideFilterAccessor: "createdDateTo",
                overrideFilterLabel: "Created Date - To",
            }]
        },
        {
            label: "Number", accessor: "customerNumber", visibility: { hasShowSetting: false },
            filterOptions: [{
                filterComponent: SearchSelectWithList(customerData?.data,
                    (customer: { customerName: any; customerNumber: any; }) => `${customer.customerName} (${customer.customerNumber})`,
                    "id", "Select Customer(s)...", true, "customerList"),
                overrideFilterLabel: "Customer(s)",
                overrideFilterAccessor: "customerIds"
            }]
        },
        {
            label: "Modified",
            accessor: "modifiedDate", visibility: { hasShowSetting: true },
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Exclude Reorders...", "excludeReOrders"),
                overrideFilterAccessor: "excludeReOrders",
                overrideFilterLabel: "Exclude Reorders",
            }]
        },

    ];





    return (
        <>
            <div className="user-container px-4 py-2">
                <div className="flex justify-between">
                    <Breadcrumb crumbs={crumbs} />
                </div>
                <ReportType type={type} setType={setType} />
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchDailyOrderCountReportApiQuery,
                        exportAction: triggerExportReportDataQuery
                    }
                    }
                    isHideApply={true}
                    defaultFilter={{ "period": "DAYS" }}
                    defaultSortOptions={{
                        accessor: "creationDate",
                        direction: "desc"
                    }}
                    defaultFilterFormExpanded={true}
                    basePermission={"DLYCUNTREPO"}
                    renderOptions={{                        
                        skipTableRender: true
                    }}
                />
            </div>
            <div />
        </>
    )
}

export default DailyOrderCountReport;